'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('../../../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _link = require('@liveauctioneers/caterwaul-components/lib/link');

var _link2 = _interopRequireDefault(_link);

var _Seo = require('./Seo.scss');

var _Seo2 = _interopRequireDefault(_Seo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Seo = function (_PureComponent) {
    (0, _inherits3.default)(Seo, _PureComponent);

    function Seo() {
        (0, _classCallCheck3.default)(this, Seo);
        return (0, _possibleConstructorReturn3.default)(this, (Seo.__proto__ || (0, _getPrototypeOf2.default)(Seo)).apply(this, arguments));
    }

    (0, _createClass3.default)(Seo, [{
        key: 'render',

        // TODO: replace strings with <FormattedMessages />
        value: function render() {
            return (0, _jsx3.default)('div', {
                className: _Seo2.default.seo
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.container
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default['column-title']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'popular_searches'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/art/chinese/1/162/'
            }, void 0, 'Chinese Art')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/clocks/74/'
            }, void 0, 'Clocks')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/coins-medals-money/24/'
            }, void 0, 'Coins and Paper Money')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/jade/25797/'
            }, void 0, 'Jade'))))), (0, _jsx3.default)('div', {
                className: _Seo2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default['column-title']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'artists_and_creators'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/finn-juhl/7645/'
            }, void 0, 'Finn Juhl')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/hans-wegner/9858/'
            }, void 0, 'Hans Wegner')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/keith-haring/14133/'
            }, void 0, 'Keith Haring')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/marc-chagall/15935/'
            }, void 0, 'Marc Chagall'))))), (0, _jsx3.default)('div', {
                className: _Seo2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default['column-title']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'brands'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/chanel/4017/'
            }, void 0, 'Chanel')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/hermes/10420/'
            }, void 0, 'Herm\xE8s')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/louis-vuitton/15385/'
            }, void 0, 'Louis Vuitton')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/rolex/21252/'
            }, void 0, 'Rolex'))))), (0, _jsx3.default)('div', {
                className: _Seo2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default['column-title']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'style_periods'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/art-deco/253/'
            }, void 0, 'Art Deco')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/byzantine/25695/'
            }, void 0, 'Byzantine')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/edwardian/274/'
            }, void 0, 'Edwardian')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/gothic/252/'
            }, void 0, 'Gothic'))))), (0, _jsx3.default)('div', {
                className: _Seo2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default['column-title']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'origins'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/japanese/163/'
            }, void 0, 'Japanese')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/tibetan/168/'
            }, void 0, 'Tibetan')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/southeast-asian/169/'
            }, void 0, 'Southeast Asian')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/c/taiwanese/165/'
            }, void 0, 'Taiwanese')))))));
        }
    }]);
    return Seo;
}(_react.PureComponent);

exports.default = Seo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/Seo/Seo.js
// module id = vDMj
// module chunks = 60